"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonIcon = exports.HeaderTextWrapper = exports.HeaderText = exports.SearchBarWrapper = exports.Header = void 0;
const native_1 = __importDefault(require("styled-components/native"));
exports.Header = native_1.default.View `
  height: ${({ height }) => height};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: ${({ center }) => (center ? 'center' : 'flex-start')};
  padding-top: 10px;
  border-bottom-width: ${({ borderWidth }) => borderWidth};
  border-color: ${(props) => props.theme.header.border};
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.header.background};
`;
exports.SearchBarWrapper = native_1.default.View `
  top: 90px;
  width: 100%;
  padding: 0 10px;
  z-index: 20;
`;
exports.HeaderText = native_1.default.Text `
  font-size: 18px;
  position: relative;
  left: -29.5px;
  color: ${({ color }) => color};
`;
exports.HeaderTextWrapper = native_1.default.View `
  flex-grow: 2;
  justify-content: center;
  align-items: center;
`;
exports.ButtonIcon = native_1.default.TouchableOpacity `
  width: 44px;
  height: 64px;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')}
  margin-left: 15px;
`;
